import React from 'react';

// SVG logos for each payment method
const LOGOS = {
  cashapp: (
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="10" fill="#00D632"/>
      <text x="20" y="27" textAnchor="middle" fontSize="22" fontWeight="900" fill="white" fontFamily="Arial">$</text>
    </svg>
  ),
  chime: (
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="10" fill="#00D4A0"/>
      <path d="M20 8 C13 8 8 13 8 20 C8 27 13 32 20 32 C25 32 29 29 31 25 L27 25 C25.5 27.5 23 29 20 29 C15 29 11 25 11 20 C11 15 15 11 20 11 C23 11 25.5 12.5 27 15 L31 15 C29 11 25 8 20 8Z" fill="white"/>
      <circle cx="28" cy="20" r="3" fill="white"/>
    </svg>
  ),
  btc: (
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="10" fill="#F7931A"/>
      <path d="M27.5 17.5C27.9 15.5 26.4 14.5 24.3 13.8L25 11L23.2 10.5L22.5 13.1C22 13 21.5 12.8 21 12.7L21.7 10.1L19.9 9.6L19.2 12.4C18.8 12.3 18.4 12.2 18.1 12.1L18.1 12.1L15.7 11.4L15.2 13.3C15.2 13.3 16.6 13.6 16.5 13.6C17.3 13.8 17.4 14.3 17.4 14.7L16.5 18.2C16.6 18.2 16.7 18.2 16.8 18.3C16.7 18.2 16.6 18.2 16.5 18.2L15.2 23.1C15.1 23.4 14.8 23.8 14.2 23.6C14.2 23.6 12.8 23.3 12.8 23.3L11.9 25.3L14.2 25.9C14.7 26 15.1 26.1 15.6 26.2L14.9 29L16.7 29.5L17.4 26.7C17.9 26.8 18.4 27 18.9 27.1L18.2 29.9L20 30.4L20.7 27.6C23.6 28.1 25.8 27.9 26.7 25.3C27.4 23.2 26.7 22 25.1 21.3C26.3 21 27.2 20.1 27.5 17.5ZM23.3 24.1C22.8 26.2 19.4 25.1 18.3 24.8L19.3 21C20.4 21.3 23.9 21.9 23.3 24.1ZM23.8 17.5C23.3 19.4 20.5 18.5 19.6 18.2L20.5 15C21.4 15.3 24.4 15.5 23.8 17.5Z" fill="white"/>
    </svg>
  ),
  ltc: (
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="10" fill="#BFBBBB"/>
      <path d="M20 6C12.3 6 6 12.3 6 20C6 27.7 12.3 34 20 34C27.7 34 34 27.7 34 20C34 12.3 27.7 6 20 6Z" fill="#BFBBBB"/>
      <path d="M20 8C13.4 8 8 13.4 8 20C8 26.6 13.4 32 20 32C26.6 32 32 26.6 32 20C32 13.4 26.6 8 20 8ZM22.3 22.5L21.6 25H14L16.2 16.5L14.5 17.1L15 15.3L16.7 14.7L18.2 9H21L19.4 15L21.1 14.4L20.6 16.2L18.9 16.8L17.3 23H22.8L22.3 22.5Z" fill="white"/>
    </svg>
  ),
  paypal: (
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="10" fill="#003087"/>
      <path d="M26.5 13.5C26.5 13.5 27.2 17.5 23.5 19.5C21.5 20.5 19 20.5 17.5 20.5L16.5 26H13L15.5 11H22C24.5 11 26.5 12 26.5 13.5Z" fill="#009CDE"/>
      <path d="M28.5 16.5C28.5 16.5 29.2 20.5 25.5 22.5C23.5 23.5 21 23.5 19.5 23.5L18.5 29H15L17.5 14H24C26.5 14 28.5 15 28.5 16.5Z" fill="white"/>
    </svg>
  ),
  other: (
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="10" fill="#F5C400"/>
      <text x="20" y="27" textAnchor="middle" fontSize="20" fontWeight="900" fill="#0a0900" fontFamily="Arial">💳</text>
    </svg>
  ),
};

const BG_COLORS = {
  cashapp: '#00D632',
  chime:   '#00D4A0',
  btc:     '#F7931A',
  ltc:     '#BFBBBB',
  paypal:  '#003087',
  other:   '#F5C400',
};

const LABELS = {
  cashapp: 'Cash App',
  chime:   'Chime',
  btc:     'Bitcoin',
  ltc:     'Litecoin',
  paypal:  'PayPal',
  other:   'Other',
};

export function PaymentLogo({ type, size = 40, style = {} }) {
  const logo = LOGOS[type] || LOGOS.other;
  return (
    <div style={{ width: size, height: size, flexShrink: 0, ...style }}>
      {React.cloneElement(logo, { width: size, height: size })}
    </div>
  );
}

export function PaymentBadge({ type, name, size = 40 }) {
  const bg = BG_COLORS[type] || '#F5C400';
  const label = name || LABELS[type] || type;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <PaymentLogo type={type} size={size} />
      <span style={{ fontWeight: 700, fontSize: size * 0.38, color: 'var(--text-primary)' }}>{label}</span>
    </div>
  );
}

export { BG_COLORS, LABELS };
export default PaymentLogo;
